import goals from "../../../../src/components/content/goals/m8";
import * as React from 'react';
export default {
  goals,
  React
};